import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject,Input, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OPERATORS, TiffUrls, videoUrls, DEFAULT_ZOOMLEVEL } from 'src/app/services/constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/api.service';
declare const L: any;
import { HelperService } from '../../../services/helper.service';
import { environment } from 'src/environments/environment';
import { MapResolutionZoomService } from 'src/app/services/map-resolution-zoom.service';

interface CustomWMSOptions extends L.WMSOptions {
  env?: string;
  styles?: string;
}

@Component({
  selector: 'app-sensorpreview',
  templateUrl: './sensorpreview.component.html',
  styleUrls: ['./sensorpreview.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SensorpreviewComponent implements OnInit {
  @Input() target: any = { geoJSON: '', area: 0 };
  sensorName: any;
  sensorImage: boolean = true;
  video: boolean = false;
  videoLink: any = '';
  @ViewChild('map', { static: false }) mapContainer!: ElementRef;
  private map: L.Map;
  zoomLevel = 3;
  mapDistance = 0;
  lattitude = 41.2;
  longitude = 74.66;
  TIFF_URLS: any;
  VIDEO_URLS: any;
  tifurl: any = '';
  currentUser: any;
  isais = false;
  baselayers:any;
  bounds:any;
  layerName:any;
  bands:any;
  algorithm:any;
  style:any;
  params: CustomWMSOptions;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<SensorpreviewComponent>,
    private readonly renderer: Renderer2,
    private readonly changDetectionRef: ChangeDetectorRef,
    private readonly spinnerService: NgxSpinnerService,
    private  readonly authService: AuthService,
    private readonly elementRef: ElementRef,
    private readonly apiService: ApiService,
    private helperService: HelperService,
    private mapResolutionZoomService: MapResolutionZoomService,
  ) {
    if (this.data?.operatorKey === OPERATORS.SPIRE) {
      this.sensorName = TiffUrls[OPERATORS.SPIRE];
      this.isais = true;
    } else if (this.data?.operatorKey === OPERATORS.CLYDE) {
      this.sensorName = TiffUrls[OPERATORS.CLYDE];
      this.isais = true;
    } else if (this.data?.operatorKey === OPERATORS.WEATHEREX) {
      this.sensorName = TiffUrls[OPERATORS.WEATHEREX];
      this.isais = true;
    } else if (this.data?.operatorKey === OPERATORS.VOYAGERADAR) {
      this.sensorName = TiffUrls[OPERATORS.VOYAGERADAR];
      this.isais = true;
    } else if (this.data?.operatorKey === OPERATORS.VESSELFINDER) {
      this.sensorName = TiffUrls[OPERATORS.VESSELFINDER];
      this.isais = true;
    } else this.sensorName = this.data?.imageName;

    if (this.data?.sensorType === 'Video') {
      this.VIDEO_URLS = videoUrls;
      this.video = true;
      this.findVideoUrl();
    } else this.video = false;
    this.TIFF_URLS = TiffUrls;
    this.authService.user.subscribe((user) => (this.currentUser = user));
  }

  ngAfterViewInit() {
    if(!this.video && !this.isais) {
       this.getPreviewImage();
    }
  }

  async getPreviewImage(){
    this.apiService.getPreviewImageLayer(this.data.sensorId, this.data.resolution, this.data.operatorKey).subscribe({
      next: (res: any) => {
        if (res.success === true && Object.keys(res.result).length > 0) {
          this.bounds = res.result?.bounds;
          this.layerName = res.result?.layer;
          this.bands = res.result?.bands;
          this.style = res.result?.style;
          this.tifurl = res.result?.layer;
          this.algorithm = res.result?.algorithm;

          this.params = this.buildParams(this.layerName, this.style, this.bands);

          if (this.layerName) {
            this.params.env = this.appendAlgoToEnv(this.params.env ?? '',this.algorithm);
          }

          this.changDetectionRef.detectChanges();
          this.initializeMap();
          this.setupEventListeners();
        } 
      },
    });
  }

  private buildParams(layerName: string, style: string, bands: any[]): CustomWMSOptions {
    const params: CustomWMSOptions = {
      layers: layerName,
      format: 'image/png',
      transparent: true,
      maxZoom: 23,
      zIndex: 1000,
    };

    if (style) {
      params.styles = style;
    }

    params.env = this.buildEnv(bands);
    return params;
  }

  private buildEnv(bands: any[]): string {
    if (bands?.length === 1) {
       return `minValue:${bands[0].min};maxValue:${bands[0].max};`;
    } else if (bands && bands.length > 1) {
      let env = '';
      for (let i = 0; i < bands.length; i++) {
        env += `b${i + 1}:${bands[i].band};`;
        if (bands[i].min && bands[i].max) {
          env += `b${i + 1}minValue:${bands[i].min};b${i + 1}maxValue:${bands[i].max};`;
        }
      }
      return env;
    }
    return '';
  }

  private appendAlgoToEnv(env: string , algorithm:string): string {
    if (!env) {
      env = '';
    }
    const algo = algorithm ? `${env}algo:${algorithm};` : `${env}algo:StretchToMinimumMaximum;`;
    return algo;  }

  private getPreviewMaxZoom(): number {
    return this.mapResolutionZoomService.calculateZoomFromResolution(
      this.data?.resolution,
      18
    );
  }

  private initializeMap(): void {
    const maxZoom = this.getPreviewMaxZoom();
    const baseLayerOptions = { maxZoom, maxNativeZoom: 18 };
    this.map = L.map(this.mapContainer?.nativeElement, {attributionControl: false, minZoom: 7, maxZoom}).setView(
      [this.lattitude, this.longitude],
      this.zoomLevel
    );
    setTimeout(() => {
      this.map.invalidateSize(); 
    }, 200); 
    const isSentinelBaseMapEnabled = environment.enableSentinelBaseMap === 'true';
    const sentinelLayer = isSentinelBaseMapEnabled
      ? environment.isCopernicusLoad === "true"
      ? L.tileLayer(
          'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
            '?SERVICE=WMTS' +
            '&REQUEST=GetTile' +
            '&VERSION=1.0.0' +
            '&LAYER=S2BASEMAP-LAYER' +
            '&STYLE=default' +
            '&FORMAT=image/png' +
            '&TILEMATRIXSET=PopularWebMercator256' +
            '&TILEMATRIX={z}' +
            '&TILEROW={y}' +
            '&TILECOL={x}',
          {
            tileSize: 256,
            opacity: 1,
            ...baseLayerOptions
          }
        )
      : L.tileLayer(
          'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
          {
            tileSize: 256,
            opacity: 1,
            ...baseLayerOptions
          }
        )
      : null;
    this.baselayers = {
      Openstreetmap: L.tileLayer(
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        baseLayerOptions
      ),
      ...(isSentinelBaseMapEnabled && sentinelLayer
        ? { Sentinel: sentinelLayer }
        : {})

    };
    let target: any;

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',  
      iconSize: [25, 41],                   
      iconAnchor: [12, 41],                  
      popupAnchor: [1, -34],                
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',  
      shadowSize: [41, 41],                   
      shadowAnchor: [12, 41]              
    });

    var overlays = {};
    L.control.layers(this.baselayers, overlays, {
      collapsed: false,  
      position: 'topright'  
    }).addTo(this.map);

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');

    if (isSentinelBaseMapEnabled && environment.isCopernicusLoad === "true") {
    var sentinel2Layer = L.tileLayer(
    'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
    '?SERVICE=WMTS' +
    '&REQUEST=GetTile' +
    '&VERSION=1.0.0' +
    '&LAYER=S2BASEMAP-LAYER' +
    '&STYLE=default' +
    '&FORMAT=image/png' +
    '&TILEMATRIXSET=PopularWebMercator256' +
    '&TILEMATRIX={z}' +
    '&TILEROW={y}' +
    '&TILECOL={x}',  {
    ...baseLayerOptions,
    attribution:
      '&copy;' + 'Sentinel-2 Cloudless by EOX'
    }
  ).addTo(this.map);
  } else if (isSentinelBaseMapEnabled) {
        var sentinel2Layer = L.tileLayer(
      'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
      {
        ...baseLayerOptions,
        attribution:
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
        tileSize: 256,
        noWrap: true
      }
    ).addTo(this.map);
  }    
    if (!isSentinelBaseMapEnabled) {
      this.baselayers['Openstreetmap'].addTo(this.map);
    }

    setTimeout(() => {
      const layersControlElement = document.querySelector('.leaflet-control-layers');
      if(layersControlElement){
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        container?.classList.remove('leaflet-control-layers-expanded');
      }
    }, 0);

    if (isSentinelBaseMapEnabled && this.baselayers['Sentinel']) {
      this.baselayers['Sentinel'].addTo(this.map);
    }

    

    this.map.on('baselayerchange', (event: any) => {
      let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
      layerBtn?.classList.remove('highlight-border');
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (container) {
        container.classList.remove('leaflet-control-layers-expanded');
        document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-2px !important')
      }
      const element = document.querySelector('#homeButton');
      if (element) {
        this.renderer.setStyle(element, 'z-index', '500');
      }
      if (event.name === "Openstreetmap") {
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        if (isSentinelBaseMapEnabled) {
          myAttrControl.removeAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        }
        myAttrControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
        this.map.setMinZoom(1);
        this.map.setMaxZoom(maxZoom);

        if (this.map.getZoom() < 1) {
        this.map.setZoom(1);
        }
       if (this.map.getZoom() > maxZoom) {
       this.map.setZoom(maxZoom);
       }
       if (isSentinelBaseMapEnabled && this.map.hasLayer(sentinel2Layer)) {
        this.map.removeLayer(sentinel2Layer);
       }
      } else if (isSentinelBaseMapEnabled) {
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
        myAttrControl.addAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        this.map.setMinZoom(7);
        this.map.setMaxZoom(maxZoom);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
         }
        if (this.map.getZoom() > maxZoom) {
        this.map.setZoom(maxZoom);
        }
      }

      if(this.imageLayer) {
        this.imageLayer.bringToFront();
      }
    });
    

    this.map.on('click', () => {
      document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-2px !important')
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (controlContainer?.classList?.contains('leaflet-control-layers-expanded')) {
          controlContainer?.classList?.remove('leaflet-control-layers-expanded');
      }
    });
    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);
    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);
    this.displayImage();
    this.calculateZoomLevel();
    this.changDetectionRef.detectChanges();
  }

  @HostListener('click', ['$event'])
  handleClick(event: any) {
    const target = event.target as HTMLElement;
    if (target.matches('.leaflet-control-layers-toggle')) {
      target.style.top = '-2px !important';
      const toggleButtons = this.elementRef.nativeElement.querySelectorAll('.leaflet-control-layers-toggle');
      if (toggleButtons.length > 1) {
        toggleButtons.forEach((element: HTMLElement, index: number) => {
          if (index == 0) {
            element.remove();
          }
        });
      }
      const layerToggleButton = document.querySelector('.leaflet-control-layers-toggle');
      if (layerToggleButton) {
        event.target.classList.add('custom-top-position');
      }
      document.querySelector('.leaflet-control-layers-toggle')?.addEventListener('click', (e) => {
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.add('highlight-border');
        if(document.querySelector('.leaflet-control-layers-expanded')) {
          document.querySelector('.align .leaflet-control-layers-toggle')?.setAttribute('style', 'top:-36px !important');
          document.querySelector('.align .leaflet-control-layers.leaflet-control.leaflet-control-layers-expanded')?.setAttribute('style', 'padding: 0px !important');

        }
      })
    } else {
      const toggleButtons = this.elementRef.nativeElement.querySelectorAll('.leaflet-control-layers-toggle');
      const elements = document.querySelectorAll('.custom-top-position');
      elements.forEach((el) => el.classList.remove('custom-top-position'));
      document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-2px !important')
    }
  }

  private setupEventListeners(): void {
    this.map.on('zoomend', this.HandleZoomEnd);
    this.map.doubleClickZoom.disable();
  }

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

  spinnerLoaderTifZoom(image: any) {
    this.spinnerService.show();

    // Event listener for tile load end
    image.on('load', () => {
      this.spinnerService.hide(); 
    });

    this.map.on('zoomstart', () => {
      this.spinnerService.show(); 
    });
          
    this.map.on('zoomend', () => {
      this.spinnerService.hide(); 
    });
  }


  ngOnInit(): void {
    // This method is intentionality left empty
  }

  imageLayer: any;
  async displayImage() {
     if (!this.map) return;
        try {
           if (this.imageLayer) {
            this.map.removeLayer(this.imageLayer);
          }

            const previewLayerData = {
              layer: {
                bounds: this.bounds,
                layer: this.layerName,
                bands: this.bands,
                tiffStyle: this.style,
                algorithm: this.algorithm,
              },
            };

            this.imageLayer = this.helperService.createWmsLayer(
              this.map,
              previewLayerData,
              'image'
            );

          this.map.setMaxZoom(this.getPreviewMaxZoom());
          this.spinnerLoaderTifZoom(this.imageLayer);
        } catch (error) {
          this.spinnerService.hide();
        }
  }

  async setMapView() {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser.country}`;
    const response = await fetch(url);
    const data = await response.json();
    if (data && data.length > 0) {
      const lat = data[0].lat;
      const lon = data[0].lon;
      this.map.setView([lat, lon], 10);
    } else {
      this.map.setView([20.5937, 78.9629], 10);
    }
    this.zoomLevel = 10; 
  }

  viewHome(event) {
    if(this.imageLayer) {
      this.map.fitBounds(this.bounds, {
        maxZoom: DEFAULT_ZOOMLEVEL,
      });
      this.zoomLevel = DEFAULT_ZOOMLEVEL;
    } else {
      this.setMapView();
    }
  }

  calculateDefautZoom() {
    const zoomLevel = this.getPreviewMaxZoom();
    this.zoomLevel = zoomLevel;
    return zoomLevel;
  }
  tif: any;
  findTiffUrl() {
    const regex = /^([A-Za-z]+)\(([\d.]+m)\)$/;
    for (let [key, value] of Object.entries(this.TIFF_URLS) as [any, any[]]) {
      const match: any = key.match(regex);
      if (match) {
        let resolution = parseFloat(this.data?.resolution.match(/[\d.]+/)[0])+'m';
        if (this.data?.operatorKey == match[1] && resolution == match[2]) {
          this.videoLink = '';
          this.tifurl = value[0];
          this.tif = value;
          break;
        }
      } else {
        if (this.data?.operatorKey == key) {
          this.videoLink = '';
          this.tif = value;
          this.tifurl = value[0];
          break;
        }
      }
    }
  }

  findVideoUrl() {
    for (let [key, value] of Object.entries(this.VIDEO_URLS)) {
      if (this.data?.operatorKey == key) {
        this.tifurl = '';
        this.videoLink = value;
        break;
      }
    }
  }
 
  onKeyPress(e: any) {
    if (e.key === 'Enter') {
      this.onNoClick();
    }
  }

  onNoClick(): void {
    this.dialogRef.close('Done');
  }
  
  public handleImageError(): void {
    this.sensorImage = false;
  }

  isMp4(link: string): boolean {
    return link.endsWith('.mp4');
  }

  isGif(link: string): boolean {
    return link.endsWith('.gif');
  }
}
